import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteLocalization } from "src/Pages/Company/OrganizationStructure/api";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";

const useDeleteLocalization = (companyId: string, structureId: string) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: async (localizationId) =>
      deleteLocalization({ companyId, structureId, localizationId }),
    onSuccess: () => {
      dynamicNotification(__("Pomyślnie usunięto lokalizację"), "success");
      queryClient.invalidateQueries({
        queryKey: ["localizations-list", companyId, structureId],
      });
    },
    onError: () => {
      dynamicNotification(__("Nie udało się usunąć lokalizacji"), "error");
    },
  });
};

export default useDeleteLocalization;
